import { COOKIE_POLICY_BANNER_HEADER_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[COOKIE_POLICY_BANNER_HEADER_MODULE_ID]: {
		moduleType: 'bannerHeader',
		bannerImageText: 'Cookie Policy',
		bannerSubText: '',
	},
}
